import type { OverlayRef } from '@angular/cdk/overlay';

import { asyncScheduler, Observable, observeOn, Subject } from 'rxjs';

import { filterBoolean } from '@recruitee/common';

import type { DialogWidth } from './dialog-config';
import type {
  DialogContainerAnimationState,
  DialogContainerComponent,
} from './dialog-container/dialog-container.component';

export class DialogRef<T = any, DialogResult = any> {
  public componentInstance: T;
  public afterClosed: Observable<DialogResult | undefined>;

  private afterClosedSubject = new Subject<DialogResult | undefined>();
  private dialogResult: DialogResult | undefined;

  constructor(
    public overlayRef: OverlayRef,
    public containerInstance: DialogContainerComponent,
  ) {
    this.afterClosed = this.afterClosedSubject.asObservable();

    containerInstance.animationStateChange
      .pipe(observeOn(asyncScheduler))
      .subscribe((state: DialogContainerAnimationState) => {
        if (state === 'exit-start') {
          // Transition the backdrop in parallel with the dialog.
          this.overlayRef.detachBackdrop();
        } else if (state === 'exit') {
          this.overlayRef.dispose();
          this.afterClosedSubject.next(this.dialogResult);
          this.afterClosedSubject.complete();
          delete this.dialogResult;
        }
      });
  }

  public setContainerWidth(width: DialogWidth): void {
    this.containerInstance.dialogConfig = { ...this.containerInstance.dialogConfig, width };
    this.containerInstance.detectChanges();
  }

  public close(dialogResult?: DialogResult): void {
    this.containerInstance
      .close$()
      .pipe(filterBoolean)
      .subscribe(() => {
        this.dialogResult = dialogResult;
      });
  }
}
